import { useMediaQuery } from 'usehooks-ts';

const useBreakpoints = () => {
  const isMobile = useMediaQuery('(max-width: 967px)');
  const isTablet = useMediaQuery('(min-width: 968px) and (max-width: 1200px)');
  const isDesktop = useMediaQuery('(min-width: 1201px)');
  return { isMobile, isTablet, isDesktop };
};

export default useBreakpoints;
